import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function initGsap() {
  gsap.registerPlugin( ScrollTrigger );

  ScrollTrigger.matchMedia({
    '(min-width: 1024px)': () => {
      gsap.to( '.place-to-belong-scrolly-text', {
        scrollTrigger: {
          trigger: '.place-to-belong-wrapper',
          start: 'top 95px',
          end: '+=100%',
          scrub: 0.1,
          pin: true,
          pinSpacing: true,
        },
      yPercent: -100,
      } );
    },
  });
}

function initEvents() {
  document.addEventListener('lazyloaded', () => {
    ScrollTrigger.refresh();
  });
}

function init() {
  initGsap();
  initEvents();
}

export default {
  init,
};
